import { Injectable } from '@angular/core';
import { App } from '@capacitor/app';
import { Camera } from '@capacitor/camera';
import { Capacitor } from '@capacitor/core';
import { Device } from '@capacitor/device';
import { Geolocation } from '@capacitor/geolocation';
import { PushNotifications } from '@capacitor/push-notifications';
import { ApiService } from '@core/services/api.service';
import { SessionService } from '@core/services/session.service';
import BackgroundGeolocation from 'cordova-background-geolocation-lt';
@Injectable({ providedIn: 'root' })
export class DeviceInfoService {
  constructor(
    private api: ApiService,
    private sessionService: SessionService,
  ) {
  }
  async startSendDeviceInfo() {
    const session = this.sessionService.getSession();
    if (!session || !session.driver) {
      return;
    }
    const isWeb = Capacitor.getPlatform() === 'web';
    const deviceInfo = isWeb
      ? { model: 'web', platform: 'web', osVersion: 'web' }
      : await Device.getInfo().catch(() => ({
        model: 'unknown',
        platform: 'unknown',
        osVersion: 'unknown',
      }));
    const appInfo = isWeb
      ? { version: 'web', build: 'web' }
      : await App.getInfo().catch(() => ({
        version: 'unknown',
        build: 'unknown',
      }));
    const geolocationPermissions = isWeb
      ? { location: 'WEB_PLATFORM' }
      : await Geolocation.checkPermissions().catch(() => ({
        location: 'UNKNOWN',
      }));
    const backgroundAuthorizationStatus = isWeb
      ? 'WEB_PLATFORM'
      : await BackgroundGeolocation.requestPermission().catch(() => 'UNKNOWN');
    let backgroundGeolocationStatus = 'UNKNOWN';
    if (!isWeb) {
      switch (backgroundAuthorizationStatus) {
        case BackgroundGeolocation.AUTHORIZATION_STATUS_ALWAYS:
          backgroundGeolocationStatus = 'AUTHORIZATION_STATUS_ALWAYS';
          break;
        case BackgroundGeolocation.AUTHORIZATION_STATUS_WHEN_IN_USE:
          backgroundGeolocationStatus = 'AUTHORIZATION_STATUS_WHEN_IN_USE';
          break;
        case BackgroundGeolocation.AUTHORIZATION_STATUS_DENIED:
          backgroundGeolocationStatus = 'AUTHORIZATION_STATUS_DENIED';
          break;
        case BackgroundGeolocation.AUTHORIZATION_STATUS_RESTRICTED:
          backgroundGeolocationStatus = 'AUTHORIZATION_STATUS_RESTRICTED';
          break;
      }
    }
    const cameraPermissions = isWeb
      ? { camera: 'WEB_PLATFORM', photos: 'WEB_PLATFORM' }
      : await Camera.checkPermissions().catch(() => ({
        camera: 'UNKNOWN',
        photos: 'UNKNOWN',
      }));
    const pushPermissions = isWeb
      ? { receive: 'WEB_PLATFORM' }
      : await PushNotifications.checkPermissions().catch(() => ({
        receive: 'UNKNOWN',
      }));
    const payload = {
      model: deviceInfo.model,
      platform: deviceInfo.platform,
      osVersion: deviceInfo.osVersion,
      appVersion: appInfo.version,
      appBuild: appInfo.build,
      language: navigator.language,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      geolocation: geolocationPermissions.location ?? 'UNKNOWN',
      backgroundGeolocation: backgroundGeolocationStatus,
      camera: cameraPermissions.camera ?? 'UNKNOWN',
      photos: cameraPermissions.photos ?? 'UNKNOWN',
      notifications: pushPermissions.receive ?? 'UNKNOWN',
    };
    this.api.post('/device/track', payload, false).subscribe({
      next: async () => {
        return;
      },
      error: (err) => {
        console.error('Error enviando info de dispositivo:', err);
      },
    });
  }
}
